import { chatMessageFragment } from '../fragments';
import { store } from '../../store';
import { subscribe } from '../utils';

export const subscribeToChatMessageCreating = async () => {
  const stream = await subscribe({
    operationName: 'ChatMessageCreated',
    query: `
      subscription ChatMessageCreated {
        chatMessageCreated {
          ...ChatMessageFragment
        }
      }

      ${chatMessageFragment}
    `,
  });

  for await (const event of stream) {
    const data = event.data?.chatMessageCreated;
    if (data) {
      store.dispatch('chatMessage/addToList', data);
    }
  }
};

export const subscribeToChatMessageUpdating = async () => {
  const stream = await subscribe({
    operationName: 'ChatMessageUpdated',
    query: `
      subscription ChatMessageUpdated {
        chatMessageUpdated {
          ...ChatMessageFragment
        }
      }

      ${chatMessageFragment}
    `,
  });

  for await (const event of stream) {
    const data = event.data?.chatMessageUpdated;
    if (data) {
      store.dispatch('chatMessage/updateInList', data);
    }
  }
};

export const subscribeToChatMessageDeleting = async () => {
  const stream = await subscribe({
    operationName: 'ChatMessageDeleted',
    query: `
      subscription ChatMessageDeleted {
        chatMessageDeleted {
          ...ChatMessageFragment
        }
      }

      ${chatMessageFragment}
    `,
  });

  for await (const event of stream) {
    const data = event.data?.chatMessageDeleted;
    if (data) {
      store.dispatch('chatMessage/removeFromList', data);
    }
  }
};

export const subscribeToLastReadMessageUpdating = async () => {
  const stream = await subscribe({
    operationName: 'LastReadMessageUpdated',
    query: `
      subscription LastReadMessageUpdated {
        lastReadMessageUpdated {
          id
          createdAt

          chatId
          accountId
          messageId

          account {
            login
          }
        }
      }
    `,
  });

  for await (const event of stream) {
    const data = event.data?.lastReadMessageUpdated;
    if (data) {
      store.dispatch('chat/updateLastReadMessage', data);
    }
  }
};

export const subscribeToTotalUnreadMessagesCountUpdating = async () => {
  const stream = await subscribe({
    operationName: 'TotalUnreadMessagesCountUpdated',
    query: `
      subscription TotalUnreadMessagesCountUpdated {
        totalUnreadMessagesCountUpdated
      }
    `,
  });

  for await (const event of stream) {
    const data = event.data?.totalUnreadMessagesCountUpdated;
    store.dispatch('chat/setUnreadCount', data || 0);
  }
};
